import React from "react";
import { Scriptbox } from "../components/Scriptbox";
import { Section } from "../components/Section";
import { Section2 } from "../components/Section2";
import { Apibox } from "../components/Apibox";
// import { Parallax, ParallaxLayer } from "@react-spring/parallax";

const ParallaxDiv = ({ takeref }: { takeref: any }) => {
  const codeString = `function add(a, b) {
        return a + b;
      }`;
  const codestring2 = ` Request

  API End Point - https://internals.pointx.one/externals/v1/create-organization/

  BODY:
  ,{
    "name":"NAME_OF_ORGANIZATION",
    "email":"GMAIL_ORGANIZATION",
    "phone":"PHONE_ORGANIZATION",
    "address":"ADDRESS_ORGANIZATION",
    "city":"CITY_ORGANIZATION",
    "state":"STATE_ORGANIZATION",
    "country":"COUNTRY_ORGANIZATION",
    "zipcode":"ZIPCODE_ORGANIZATION",
    "website":"WEBSITE_ORGANIZATION"
}
  
  `;
  return (
    <Section
      heading="Connect RewardWise With Your Organization"
      takeref={takeref}
    >
      <Section2 codelang="python" codestring={codestring2}>
        <Apibox name="model" datatype={"string"} req_type="required">
          <h1 style={{ fontSize: "32px", fontWeight: "bold" }}>Overview</h1>
          <p>
            The OrganisationView API endpoint provides a seamless way to create
            an organization along with its associated user account in a single
            step. This powerful endpoint is specifically designed to cater to
            the needs of both merchants and customers who are looking to
            register their organizations and obtain a unique API key for smooth
            integration with our platform. When you use this API, it not only
            sets up the organization's details but also generates a
            corresponding user account that is tied to the organization.
            Additionally, an API key is automatically created and assigned to
            the organization, enabling you to access various features and
            functionalities of the system. This endpoint is particularly useful
            for merchants who aim to integrate their business operations with
            advanced tools, as well as customers seeking to streamline their
            organizational setup. By providing the necessary information during
            the registration process, users can ensure the successful creation
            of their organization without any hassle.
          </p>
          <br />
          <b>
            Endpoint :
            https://internals.pointx.one/externals/v1/create-organization/
          </b>
          <br />
          <b>METHOD : POST</b>
          <p><br/>
            If Provided information is all correct then You Will get{" "}
            <b>RESPONSE</b> as
          </p>
          <br />
          <b>
            "error": False, <br />
            "msg": "Organization and API Key created successfully", <br />
            "api_key": YOUR_ORGANIZATION_API_KEY
          </b>

          {/* <p>Thi is the api data and all</p> */}
          {/* <p>Thi is the api data and all</p> */}
        </Apibox>
        {/* {Array.from({ length: 40 }).map((_, index) => (
          <p key={index} className="long-paragraph">
            long para
          </p>
        ))} */}
      </Section2>
    </Section>
  );
};

export default ParallaxDiv;
